import React, { useCallback, useState, useRef } from 'react';
import LanguageIcon from 'pencil/icons/Language';
import MenuItem from 'pencil/MenuItem';
import Menu from 'pencil/Menu';
import IconButton from 'pencil/IconButton';
import RootRef from 'pencil/RootRef';

const LanguageSwitcherMenu = ({ locale: selectedLocale, selectLocale, locales }) => {
  const [isOpened, setIsOpened] = useState(false);

  const anchorEl = useRef();

  const handleMenu = useCallback(() => {
    setIsOpened(!isOpened);
  }, []);

  const handleClose = useCallback(() => {
    setIsOpened(false);
    location.reload();
  }, []);

  return (
    <>
      <RootRef rootRef={anchorEl}>
        <IconButton
          onClick={handleMenu}
          aria-owns={isOpened ? 'menu-appbar' : undefined}
          aria-haspopup="true"
          color="inherit"
        >
          <LanguageIcon />
        </IconButton>
      </RootRef>
      <Menu
        anchorEl={anchorEl.current}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={isOpened}
        onClose={handleClose}
      >
        {locales.map((locale) => (
          <MenuItem
            disabled={locale.key === selectedLocale.key || locale.disabled === true}
            selected={locale.key === selectedLocale.key}
            key={locale.key}
            onClick={() => {
              selectLocale(locale.key);
              handleClose();
            }}
          >
            {locale.name}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSwitcherMenu;
